<template>
  <div v-click-outside="() => (showDropdown = false)" class="dropdown-container">
    <div class="dropdown-reveal">
      <app-check-box
        size="small"
        style="display:inline-block"
        :checked="selectAllOrNone"
        @change="onSelectAllOrNone($event)"
      ></app-check-box>
      <div class="chev-container">
        <font-awesome-icon
          :icon="showDropdown ? 'chevron-up' : 'chevron-down'"
          @click="toggleDropdown"
        />
      </div>
    </div>
    <div v-show="showDropdown" class="dropdown-menu">
      <ul>
        <li v-for="item in menuItems" :key="item.icon" @click="onMenuClick(item.clickaction)">
          <span><font-awesome-icon :icon="item.icon"/></span>
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CheckBox from './Checkbox.vue';
import vClickOutside from 'v-click-outside';

export default {
  name: 'BulkActionDropdown',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    appCheckBox: CheckBox
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showDropdown: false,
      selectAllOrNone: false
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    onMenuClick(bulkAction) {
      this.$emit('bulk-action-selected', bulkAction);
      this.toggleDropdown();
    },
    onSelectAllOrNone(event) {
      this.showDropdown = event.checked;
      this.selectAllOrNone = !this.selectAllOrNone;
      this.$emit('all-none-selected', event);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';

.dropdown-container {
  position: relative;

  .dropdown-reveal {
    display: flex;
    padding: 10px 10px;
    margin-right: 30px;
    border: 1px solid $row-border;
    width: 70px;
    height: 50px;
  }

  .chev-container {
    width: 15px;
    margin-left: 5px;
    padding-top: 4px;
  }

  .dropdown-menu {
    position: absolute;
    border: 1px solid $light-grey-2;
    background-color: $white;
    opacity: 1;
    width: 275px;
    z-index: 50;

    > ul {
      list-style: none;
      margin: 0;
      padding: 0;
      > li {
        padding: 15px 15px;

        border-top: 1px solid $row-border;
        &:hover {
          cursor: pointer;
          background-color: $light-grey-2;
        }

        > span {
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
